import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { baseURL } from "../../BaseUrl";
//fucntion to retrive the token from the local storage
const getToken = () => localStorage.getItem("workManagement")
// API headers including token
const getAuthHeaders = () => ({
   headers:{
    Authorization:`Bearer ${getToken()}`
   }
})
export const getAllClientdata = createAsyncThunk(
    "client/getAllClientdata",
    async () => {
        try {
            const response = await baseURL.get(`/client/`,getAuthHeaders());
            // console.log("response===>",response.data)
            return response.data.data
        }catch (error){
            throw error;
        }

    }
);
export const createClientdata = createAsyncThunk(
    "client/createClientdata",
    async (data) => {
        try {
           const response = await baseURL.post(`/client/`,data,getAuthHeaders()) 
        //    console.log("response.data===>",response.data)
           return response.data.data
        }catch(error){
            throw error;
        }
    }
)
export const getSingleClientdata = createAsyncThunk(
    "client/getSingleClientdata",
    async (id) => {
        try{
            const response = await baseURL.get(`/client/${id}`,getAuthHeaders())
            // console.log("response.data===>",response.data)
            return response.data.data
        }catch(error){
            throw error
        }
    }
)
export const updateClientData = createAsyncThunk(
    "client/updateClientData",
    async (data) => {
        try{
            const response = await baseURL.patch(`/client/`,data,getAuthHeaders())
            // console.log("response.data===>",response.data)
            return response.data.data
        }catch(error){
            throw error
        }
    }
)
export const getClientListdata = createAsyncThunk(
    "client/getClientListdata",
    async (id) => {
        try{
            const response = await baseURL.get(`client/client-list/${id}`,getAuthHeaders())
            // console.log("response.data===>",response.data)
            return response.data.data
        }catch(error){
            throw error
        }
    }
)
export const clientSlice = createSlice({
    name:"client",
    initialState:{
        clientData:[],
        singleClientData:{},
        clientList:[],
        loading:false,
        error:null,
    },
    reducers:{},
    extraReducers:(builder) =>{
        builder
        .addCase(getAllClientdata.pending,(state)=>{
            state.loading= false
        })
        .addCase(getAllClientdata.fulfilled,(state,action)=>{
            state.loading=false
            state.clientData=action.payload
        })
        .addCase(getAllClientdata.rejected,(state,action)=>{
            state.loading=false
            state.error=action.error
        })
        builder
       .addCase(getSingleClientdata.pending,(state)=>{
        state.loading = false
       })
       .addCase(getSingleClientdata.fulfilled,(state,action)=>{
        state.loading= false
        state.singleClientData=action.payload
       })
       .addCase(getSingleClientdata.rejected,(state,action)=>{
        state.loading=false
        state.error=action.error
       })
       builder
       .addCase(getClientListdata.pending,(state)=>{
        state.loading = false
       })
       .addCase(getClientListdata.fulfilled,(state,action)=>{
        state.loading= false
        state.clientList=action.payload
       })
       .addCase(getClientListdata.rejected,(state,action)=>{
        state.loading=false
        state.error=action.error
       })
    }
})
export const getClientData = (state) => state.client.clientData
export const getUniqueClientData = (state)=>state.client.singleClientData
export const getClientList = (state) => state.client.clientList
export default clientSlice.reducer